import { useTexte } from '../../texte'
import type { OutboxEntry } from '../../lib/outbox'
import { bubbleTime } from '../../lib/format'
import { Warteknoepfe, Wartemarke } from './Wartend'

/**
 * A poll that waits for the net (1.80.0, from use: "Abstimmungen auch
 * offline").
 *
 * It stands where the poll will stand, pale and dashed like a waiting
 * message, with the question and the answers as they were written -- and
 * without buttons to vote or percentages: nothing of that exists before the
 * server has the poll. The marker and the buttons are the waiting bubble's,
 * like `Wetterwartet`, so that a stuck poll looks and works like a stuck
 * message.
 */
export function Abstimmungwartet({ eintrag }: { eintrag: OutboxEntry }) {
  const t = useTexte()
  const abstimmung = eintrag.abstimmung
  if (abstimmung === undefined) return null
  const antworten = abstimmung.options.map((a) => a.trim()).filter((a) => a !== '')
  return (
    <div className="bubble-row bubble-row--own">
      <div className="bubble bubble--wartet" data-abstimmung-wartet={eintrag.key}>
        <span className="bubble__kopfzeile">
          <span className="bubble__wer" />
          <span className="bubble__meta">
            {bubbleTime(eintrag.angelegt)}
            <Wartemarke eintrag={eintrag} />
          </span>
        </span>
        <div className="abstimmung">
          <p className="abstimmung__frage">{abstimmung.question}</p>
          <ul className="abstimmung__antworten">
            {antworten.map((antwort, i) => (
              <li key={i}>
                <span className="abstimmung__antwort">
                  <span className="abstimmung__text">{antwort}</span>
                </span>
              </li>
            ))}
          </ul>
          <p className="abstimmung__hinweis">{t.chat.abstimmungKommtMitNetz}</p>
        </div>
        {eintrag.problem !== undefined && <p className="wartet-problem">{eintrag.problem}</p>}
        <Warteknoepfe eintrag={eintrag} />
      </div>
    </div>
  )
}
